import React from "react";
import { BsFillTelephonePlusFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";

const FooterPort = () => {
  return (
    <div className="row overflow-hidden mainDropFilter" id="Footer">
      <div  className="col-12 px-5 footerMAindiv d-md-flex">
        <a  href="mailto:ishtiaq.ties@gmail.com" className="text-center mail d-flex align-items-center">
          <MdEmail className="mail_icon" /> ishtiaq.ties@gmail.com
        </a>
        <a   style={{color: 'blue',}} className="text-center mail d-flex align-items-center">
          <BsFillTelephonePlusFill className="mail_icon"  /> +92-344908483
        </a>
      </div>
    </div>
  );
};

export default FooterPort;
